var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroidButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 44,
    viewBox: "0 0 150 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.705575,
    y: 0.705575,
    width: 148.589,
    height: 42.5889,
    rx: 7.29443,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.707 23.9262C73.0937 23.9262 70.9636 25.8941 70.9636 28.6045C70.9636 31.2984 73.0937 33.2828 75.707 33.2828C78.3214 33.2828 80.4514 31.2984 80.4514 28.6045C80.4503 25.8941 78.3203 23.9262 75.707 23.9262ZM75.707 31.4414C74.2748 31.4414 73.0403 30.2721 73.0403 28.6056C73.0403 26.9215 74.2759 25.7698 75.707 25.7698C77.1392 25.7698 78.3737 26.9215 78.3737 28.6056C78.3737 30.271 77.1392 31.4414 75.707 31.4414ZM65.3581 23.9262C62.7448 23.9262 60.6148 25.8941 60.6148 28.6045C60.6148 31.2984 62.7448 33.2828 65.3581 33.2828C67.9725 33.2828 70.1025 31.2984 70.1025 28.6045C70.1025 25.8941 67.9725 23.9262 65.3581 23.9262ZM65.3581 31.4414C63.9259 31.4414 62.6914 30.2721 62.6914 28.6056C62.6914 26.9215 63.927 25.7698 65.3581 25.7698C66.7903 25.7698 68.0248 26.9215 68.0248 28.6056C68.0259 30.271 66.7903 31.4414 65.3581 31.4414ZM53.0492 25.3628V27.3472H57.847C57.7037 28.4637 57.3281 29.2788 56.7548 29.8453C56.057 30.5361 54.9648 31.2984 53.0492 31.2984C50.0959 31.2984 47.787 28.9411 47.787 26.0173C47.787 23.0935 50.0959 20.7362 53.0492 20.7362C54.6425 20.7362 55.8059 21.3566 56.6648 22.1541L58.0792 20.7538C56.8792 19.6197 55.287 18.7518 53.0492 18.7518C49.0036 18.7518 45.6025 22.0122 45.6025 26.0173C45.6025 30.0224 49.0036 33.2828 53.0492 33.2828C55.2325 33.2828 56.8803 32.5733 58.1681 31.2445C59.4925 29.9333 59.9048 28.0897 59.9048 26.6014C59.9048 26.1416 59.8692 25.7159 59.797 25.3617H53.0492V25.3628ZM103.391 26.9039C102.998 25.8589 101.798 23.9262 99.3459 23.9262C96.9114 23.9262 94.8881 25.8226 94.8881 28.6045C94.8881 31.2269 96.8937 33.2828 99.5781 33.2828C101.744 33.2828 102.997 31.9716 103.517 31.2093L101.906 30.1456C101.369 30.9255 100.635 31.4392 99.5781 31.4392C98.5225 31.4392 97.7703 30.9607 97.287 30.0213L103.606 27.4341L103.391 26.9039ZM96.947 28.4637C96.8937 26.6553 98.3614 25.7346 99.4181 25.7346C100.241 25.7346 100.939 26.1427 101.173 26.7268L96.947 28.4637ZM91.8103 33.0001H93.8859V19.249H91.8103V33.0001ZM88.4081 24.9723H88.337C87.8714 24.4223 86.9759 23.9262 85.8492 23.9262C83.4859 23.9262 81.3203 25.9821 81.3203 28.6232C81.3203 31.2456 83.4859 33.2839 85.8492 33.2839C86.977 33.2839 87.8714 32.7878 88.337 32.2213H88.4081V32.8945C88.4081 34.6842 87.4414 35.6412 85.8848 35.6412C84.6137 35.6412 83.8259 34.7381 83.5037 33.9758L81.6959 34.7205C82.2148 35.9602 83.5925 37.4848 85.8848 37.4848C88.3192 37.4848 90.3781 36.0669 90.3781 32.6107V24.2111H88.4092V24.9723H88.4081ZM86.0281 31.4414C84.5959 31.4414 83.397 30.2534 83.397 28.6232C83.397 26.9743 84.5959 25.7698 86.0281 25.7698C87.4414 25.7698 88.5514 26.9743 88.5514 28.6232C88.5514 30.2534 87.4414 31.4414 86.0281 31.4414ZM113.118 19.249H108.15V33.0001H110.223V27.7905H113.117C115.415 27.7905 117.675 26.1438 117.675 23.5203C117.675 20.8968 115.416 19.249 113.118 19.249ZM113.171 25.8765H110.223V21.163H113.171C114.721 21.163 115.601 22.4335 115.601 23.5203C115.601 24.5851 114.721 25.8765 113.171 25.8765ZM125.985 23.902C124.484 23.902 122.929 24.5565 122.286 26.0074L124.126 26.7675C124.519 26.0074 125.253 25.7588 126.02 25.7588C127.093 25.7588 128.183 26.3957 128.2 27.5276V27.6695C127.825 27.4572 127.02 27.1393 126.038 27.1393C124.055 27.1393 122.035 28.2184 122.035 30.2347C122.035 32.075 123.661 33.2597 125.484 33.2597C126.877 33.2597 127.646 32.6404 128.128 31.9144H128.199V32.9759H130.201V27.7036C130.203 25.2638 128.36 23.902 125.985 23.902ZM125.734 31.4381C125.056 31.4381 124.108 31.1015 124.108 30.2699C124.108 29.2084 125.288 28.8014 126.307 28.8014C127.217 28.8014 127.647 28.9961 128.2 29.2612C128.039 30.5361 126.931 31.4381 125.734 31.4381ZM137.493 24.2023L135.116 30.1643H135.045L132.578 24.2023H130.345L134.044 32.5348L131.935 37.1702H134.097L139.798 24.2023H137.493ZM118.819 33.0001H120.891V19.249H118.819V33.0001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6863 11.2673C52.6863 12.1891 52.4107 12.9228 51.8585 13.4706C51.2318 14.1218 50.4141 14.4474 49.4096 14.4474C48.4474 14.4474 47.6285 14.1174 46.9563 13.4574C46.283 12.7963 45.9463 11.9779 45.9463 11.0011C45.9463 10.0232 46.283 9.20476 46.9563 8.54476C47.6285 7.88366 48.4474 7.55366 49.4096 7.55366C49.8874 7.55366 50.3441 7.64606 50.7774 7.82976C51.2118 8.01456 51.5596 8.25986 51.8196 8.56676L51.2341 9.14756C50.793 8.62506 50.1852 8.36436 49.4085 8.36436C48.7063 8.36436 48.0996 8.60856 47.5874 9.09696C47.0752 9.58536 46.8196 10.2201 46.8196 11C46.8196 11.7799 47.0752 12.4146 47.5874 12.903C48.0996 13.3914 48.7063 13.6356 49.4085 13.6356C50.153 13.6356 50.7741 13.3903 51.2707 12.8986C51.593 12.5785 51.7796 12.133 51.8296 11.5621H49.4085V10.769H52.6385C52.6718 10.9417 52.6863 11.1078 52.6863 11.2673Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8086 8.51072H54.7731V10.6029H57.5108V11.396H54.7731V13.4882H57.8086V14.3H53.9164V7.70002H57.8086V8.51072Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4207 14.3H60.564V8.51072H58.7018V7.70002H63.2829V8.51072H61.4207V14.3Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5973 14.3V7.70002H67.454V14.3H66.5973Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2531 14.3H70.3964V8.51072H68.5342V7.70002H73.1153V8.51072H71.2531V14.3Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7873 13.4475C81.1317 14.1141 80.3173 14.4474 79.3428 14.4474C78.3684 14.4474 77.5539 14.1141 76.8995 13.4475C76.2439 12.7809 75.9173 11.9647 75.9173 11C75.9173 10.0353 76.2439 9.21911 76.8995 8.55251C77.5539 7.88591 78.3684 7.55151 79.3428 7.55151C80.3117 7.55151 81.125 7.88701 81.7828 8.55691C82.4406 9.22681 82.7695 10.0408 82.7695 11C82.7695 11.9647 82.4417 12.7809 81.7873 13.4475ZM77.5317 12.8942C78.025 13.3892 78.6284 13.6356 79.3428 13.6356C80.0573 13.6356 80.6617 13.3881 81.1539 12.8942C81.6473 12.3992 81.895 11.7678 81.895 11C81.895 10.2322 81.6473 9.60081 81.1539 9.10581C80.6617 8.61081 80.0573 8.36441 79.3428 8.36441C78.6284 8.36441 78.025 8.61191 77.5317 9.10581C77.0395 9.60081 76.7917 10.2322 76.7917 11C76.7917 11.7678 77.0395 12.3992 77.5317 12.8942Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9717 14.3V7.70002H85.014L88.254 12.8337H88.2906L88.254 11.5621V7.70002H89.1106V14.3H88.2162L84.8262 8.91663H84.7895L84.8262 10.1882V14.3H83.9717Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6863 11.2673C52.6863 12.1891 52.4107 12.9228 51.8585 13.4706C51.2318 14.1218 50.4141 14.4474 49.4096 14.4474C48.4474 14.4474 47.6285 14.1174 46.9563 13.4574C46.283 12.7963 45.9463 11.9779 45.9463 11.0011C45.9463 10.0232 46.283 9.20476 46.9563 8.54476C47.6285 7.88366 48.4474 7.55366 49.4096 7.55366C49.8874 7.55366 50.3441 7.64606 50.7774 7.82976C51.2118 8.01456 51.5596 8.25986 51.8196 8.56676L51.2341 9.14756C50.793 8.62506 50.1852 8.36436 49.4085 8.36436C48.7063 8.36436 48.0996 8.60856 47.5874 9.09696C47.0752 9.58536 46.8196 10.2201 46.8196 11C46.8196 11.7799 47.0752 12.4146 47.5874 12.903C48.0996 13.3914 48.7063 13.6356 49.4085 13.6356C50.153 13.6356 50.7741 13.3903 51.2707 12.8986C51.593 12.5785 51.7796 12.133 51.8296 11.5621H49.4085V10.769H52.6385C52.6718 10.9417 52.6863 11.1078 52.6863 11.2673Z",
    stroke: "white",
    strokeWidth: 0.28223,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8086 8.51072H54.7731V10.6029H57.5108V11.396H54.7731V13.4882H57.8086V14.3H53.9164V7.70002H57.8086V8.51072Z",
    stroke: "white",
    strokeWidth: 0.28223,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4207 14.3H60.564V8.51072H58.7018V7.70002H63.2829V8.51072H61.4207V14.3Z",
    stroke: "white",
    strokeWidth: 0.28223,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5973 14.3V7.70002H67.454V14.3H66.5973Z",
    stroke: "white",
    strokeWidth: 0.28223,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2531 14.3H70.3964V8.51072H68.5342V7.70002H73.1153V8.51072H71.2531V14.3Z",
    stroke: "white",
    strokeWidth: 0.28223,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7873 13.4475C81.1317 14.1141 80.3173 14.4474 79.3428 14.4474C78.3684 14.4474 77.5539 14.1141 76.8995 13.4475C76.2439 12.7809 75.9173 11.9647 75.9173 11C75.9173 10.0353 76.2439 9.21911 76.8995 8.55251C77.5539 7.88591 78.3684 7.55151 79.3428 7.55151C80.3117 7.55151 81.125 7.88701 81.7828 8.55691C82.4406 9.22681 82.7695 10.0408 82.7695 11C82.7695 11.9647 82.4417 12.7809 81.7873 13.4475ZM77.5317 12.8942C78.025 13.3892 78.6284 13.6356 79.3428 13.6356C80.0573 13.6356 80.6617 13.3881 81.1539 12.8942C81.6473 12.3992 81.895 11.7678 81.895 11C81.895 10.2322 81.6473 9.60081 81.1539 9.10581C80.6617 8.61081 80.0573 8.36441 79.3428 8.36441C78.6284 8.36441 78.025 8.61191 77.5317 9.10581C77.0395 9.60081 76.7917 10.2322 76.7917 11C76.7917 11.7678 77.0395 12.3992 77.5317 12.8942Z",
    stroke: "white",
    strokeWidth: 0.28223,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9717 14.3V7.70002H85.014L88.254 12.8337H88.2906L88.254 11.5621V7.70002H89.1106V14.3H88.2162L84.8262 8.91663H84.7895L84.8262 10.1882V14.3H83.9717Z",
    stroke: "white",
    strokeWidth: 0.28223,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1790_191685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5955 8.2916C11.2722 8.6304 11.0811 9.1562 11.0811 9.8371V34.1647C11.0811 34.8467 11.2722 35.3714 11.5955 35.7102L11.6777 35.7894L25.4433 22.1615V22.0009V21.8403L11.6777 8.2113L11.5955 8.2916Z",
    fill: "url(#paint0_linear_1790_191685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0311 26.7057L25.4434 22.1616V22.001V21.8404L30.0322 17.2974L30.1356 17.3557L35.5722 20.4137C37.1245 21.2871 37.1245 22.716 35.5722 23.5905L30.1356 26.6485L30.0311 26.7057Z",
    fill: "url(#paint1_linear_1790_191685)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1790_191685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1357 26.6475L25.4424 22.0011L11.5957 35.7104C12.1068 36.2472 12.9524 36.3132 13.9046 35.7786L30.1357 26.6475Z",
    fill: "url(#paint2_linear_1790_191685)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.1357 17.3547L13.9046 8.22466C12.9524 7.68896 12.1068 7.75606 11.5957 8.29286L25.4435 22.0022L30.1357 17.3547Z",
    fill: "url(#paint3_linear_1790_191685)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.705575,
    y: 0.705575,
    width: 148.589,
    height: 42.5889,
    rx: 7.29443,
    stroke: "#A6A6A6",
    strokeWidth: 1.41115
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1790_191685",
    x: 11.0811,
    y: 7.85498,
    width: 25.6553,
    height: 28.2928,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.211672
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1790_191685"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.211672
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1790_191685",
    result: "effect2_innerShadow_1790_191685"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1790_191685",
    x: 11.5957,
    y: 22.0011,
    width: 18.54,
    height: 14.1467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.211672
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1790_191685"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1790_191685",
    x1: 24.2231,
    y1: 9.5797,
    x2: 5.76379,
    y2: 28.2254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1790_191685",
    x1: 37.5928,
    y1: 22.001,
    x2: 10.7085,
    y2: 22.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1790_191685",
    x1: 27.5869,
    y1: 24.5244,
    x2: 2.55384,
    y2: 49.8103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1790_191685",
    x1: 8.10837,
    y1: 0.194444,
    x2: 19.2863,
    y2: 11.4853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidButton);
export default __webpack_public_path__ + "static/media/android_button.de72a53c5364ffb17400a9e717312546.svg";
export { ForwardRef as ReactComponent };